import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import type { Buyer } from '../types/content';
type Notice = Buyer & {
  minutes: number;
  key: number;
};
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let hideTimer: number;
    let showTimer: number;
    const show = () => {
      const buyer = buyers[index % buyers.length];
      index += 1 + Math.floor(Math.random() * 3);
      setNotice({
        ...buyer,
        minutes: 1 + Math.floor(Math.random() * 14),
        key: Date.now()
      });
      hideTimer = window.setTimeout(() => {
        setNotice(null);
        showTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 flex md:left-6 md:right-auto" aria-live="polite" data-id="element-27" data-mp="1fuh9wavriwj4">
      <AnimatePresence data-id="element-28" data-mp="1axhcspgw5445">
        {notice && !dismissed && <motion.div key={notice.key} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-2 shadow-card ring-1 ring-line" data-id="element-29" data-mp="n86ah3jw71nw">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-lg font-black text-gold" data-id="element-30" data-mp="28mkifwkca196">
              {notice.name.charAt(0)}
            </span>
            <div className="min-w-0 flex-1 text-sm leading-snug" data-id="element-31" data-mp="2aqntuvbyk16x">
              <p className="font-bold text-heading" data-id="element-32" data-mp="2fmcw56fd3w6x">
                {notice.name} <span className="font-medium text-body" data-id="element-33" data-mp="2km7prhqiuzvo">from {notice.country}</span>
              </p>
              <p className="text-body" data-id="element-34" data-mp="2pmdjr4k9kygx">just purchased the Hair Transplant Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-35" data-mp="1rybvejofdk22">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-36" data-mp="1wwwv8hzrm1pz" />
                {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="self-start rounded-full p-1 text-body transition-colors duration-150 hover:bg-paper" aria-label="Dismiss notification" data-id="element-37" data-mp="21uoopgg25vwa">
              <XIcon className="h-4 w-4" data-id="element-38" data-mp="1e5vm514xkpsp" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}